/* RESPONSIBLE TEAM: team-standalone */

import StandardizedPlatform from './standardized-platform';
import { IntegrationState, IntegrationType, StandalonePlatform } from '../constants';
import type ApplicationInstance from '@ember/application/instance';
import { GenericConversationExtractionRowData } from './component-data/conversation-extraction-row-data';
import FreshdeskConversationExcerpt from './component-data/freshdesk/conversation-excerpt';
import GenericOnboardingGuideStep from './component-data/generic/onboarding-guide-step';
import GenericRequestAccessData from './component-data/generic/request-access';
import FreshdeskChannelTargetingBodyData from './component-data/freshdesk/channel-targeting-body-data';
import { GenericAiContentLibraryData } from './component-data/ai-content-library';
import { GenericKnowledgeContentData } from './component-data/knowlege-content-data';
import { GenericComposerOverflowMenuTooltipData } from './component-data/overflow-menu-tooltip-data';
import { GenericExampleCodeSnippetData } from './component-data/example-code-snippet-data';
import type Platform from './platform';

export default class FreshdeskPlatform extends StandardizedPlatform {
  constructor(owner: ApplicationInstance) {
    super(owner);
  }

  protected get integrationTypes(): IntegrationType[] {
    return [IntegrationType.FreshdeskTickets, IntegrationType.Freshchat];
  }

  get componentData(): Platform['componentData'] {
    return {
      'conversation-extraction': GenericConversationExtractionRowData,
      'conversation-excerpt': new FreshdeskConversationExcerpt(this),
      'knowledge-hub-modal': null,
      'onboarding-guide-step': new GenericOnboardingGuideStep(this),
      'request-access': new GenericRequestAccessData(this),
      'channel-targeting-body': new FreshdeskChannelTargetingBodyData(),
      'ai-content-library': GenericAiContentLibraryData,
      'knowledge-content': GenericKnowledgeContentData,
      'composer-overflow-menu-tooltip': GenericComposerOverflowMenuTooltipData,
      'example-code-snippet': GenericExampleCodeSnippetData,
      'conversation-ingestion': null,
    } as const;
  }

  async loadConfigData() {
    // TODO
  }

  async loadRequiredData() {
    return super.loadRequiredData();
  }

  get supportsErrorLogs() {
    return true;
  }

  async loadDataFields() {
    return super.loadDataFields();
  }

  get isConnected() {
    return false;
  }

  get hasInstalledCopilot() {
    return false;
  }

  get supportsHistoricalSyncing() {
    return false;
  }

  get historicalSyncingEnabled() {
    return false;
  }

  get finIsLive() {
    return false;
  }

  get finIsPaused() {
    return false;
  }

  get showAnalyzeSectionConnectCta() {
    return false;
  }

  get connectionState() {
    return IntegrationState.NotConfigured;
  }

  get icon() {
    return 'freshdesk' as const;
  }

  get platformKey() {
    return StandalonePlatform.Freshdesk;
  }

  get supportsFinPlayground() {
    return false;
  }

  get supportsConversationSyncing() {
    return false;
  }

  findMappedConversationField(_id: string | undefined) {
    return undefined;
  }

  isMappedUserAttribute(attributeIdentifier: string) {
    return super.isMappedUserAttribute(attributeIdentifier);
  }

  isMappedCompanyAttribute(attributeIdentifier: string) {
    return super.isMappedCompanyAttribute(attributeIdentifier);
  }

  isMappedConversationAttribute(attributeIdentifier: string) {
    return super.isMappedConversationAttribute(attributeIdentifier);
  }

  get ticketFields() {
    return super.ticketFields;
  }

  get userFields() {
    return super.userFields;
  }

  get companyFields() {
    return super.companyFields;
  }
}
